const INITIAL_STATE = {
  solicitacoesList: {
    data : []
  },
  parceiros: [],
  usuarios: [],
  solicitacoesPagination: [],
  detalhes:{}
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'VOUCHER_FETCHED':
      return { ...state, solicitacoesList: action.payload }
    case 'VOUCHER_GET_PARCEIROS':
      return { ...state, parceiros: action.payload.parceiros }
    case 'VOUCHER_GET_PARCEIRO_USUARIOS':
      return { ...state, usuarios: action.payload.usuarios }
    case 'VOUCHER_PAGINATION':
      return { ...state, solicitacoesPagination: action.payload }
    case 'VOUCHER_DETALHES':
      return { ...state, detalhes: action.payload }
    default:
      return state
  }
}